import { key, keyCodes } from './helpers';

jQuery(function ($) {
  const toolsToggle = $('.patient-tools-toggle');
  const MENU_LINKS = '.patient-tools a';

  $(MENU_LINKS).attr('tabindex', '-1');
  toolsToggle.each(function () {
    $(this).init.prototype.isToolsOpen = function () {
      return $(this).attr('aria-expanded') === 'true';
    };

    $(this).init.prototype.toggleTools = function () {
      $(this).setToolsOpen(!this.isToolsOpen());
    };

    $(this).init.prototype.setToolsOpen = function (open) {
      _ukhcSetNavDimActive(
        open,
        () => $(this).setToolsOpen(false), // onStopDim
      );
      if (open) {
        $(MENU_LINKS).attr('tabindex', '0');
        $(this).attr('aria-expanded', 'true');
        $(this).attr('aria-label', 'Close patient tools');
        $(this).css('z-index', 102);
        $('.patient-tools').addClass('open');
      } else {
        $(MENU_LINKS).attr('tabindex', '-1');
        $(this).attr('aria-expanded', 'false');
        $(this).attr('aria-label', 'Open patient tools');
        $(this).css('z-index', 99);
        $('.patient-tools').removeClass('open');
      }
    };
  });
  $('.patient-tools').click((e) => e.stopPropagation());
  toolsToggle.interact(() => toolsToggle.toggleTools());
  toolsToggle.keydown(function (e) {
    const which = key(e);
    if ($(this).isToolsOpen()) {
      if (which === keyCodes.tab && !e.shiftKey) {
        // Forward to first item
        e.preventDefault();
        $(MENU_LINKS)[0].focus();
      } else if (which === keyCodes.tab && e.shiftKey) {
        // Back up before menu
        toolsToggle.toggleTools();
      }
    }
  });
  // Global esc toggles menu off
  $(document).keyup(function (e) {
    if (key(e) === keyCodes.esc) {
      if (toolsToggle.isToolsOpen()) {
        toolsToggle.toggleTools();
      }
    }
  });
  $(MENU_LINKS).on('keydown', function (e) {
    const item = e.target;
    const which = key(e);

    const allVisibleItems = $(MENU_LINKS);
    if (item === allVisibleItems.first()[0] && which === keyCodes.tab && e.shiftKey) {
      // Back to toggle from first item
      e.preventDefault();
      toolsToggle.focus();
    } else if (item === allVisibleItems.last()[0] && which === keyCodes.tab && !e.shiftKey) {
      // Forward after latest item
      e.preventDefault();
      $('.header-search-toggle').focus();
      toolsToggle.toggleTools();
    }
  });
});
